import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import { TABLE_ROW_TYPE } from '../../services/ViewService';
import TablePaginationActions from './TablePaginationActions';
import HeaderRow from './HeaderRow';
import tableWith, { NO_SORT_PROPERTY } from './tableWith';

import './TableViewComponent.scss';

class TableViewComponent extends React.PureComponent {
  static propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    rowNodes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    checked: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tableHandler: PropTypes.shape({
      onChangePage: PropTypes.func,
      onChangeRowsPerPage: PropTypes.func,
    }).isRequired,
    headerButtons: PropTypes.func,
    rowButtons: PropTypes.func,
    page: PropTypes.number,
    rowsPerPage: PropTypes.number,
    sortedColumn: PropTypes.shape({}),
    sortOrder: PropTypes.string,
    editedRow: PropTypes.shape({}),
    editValues: PropTypes.arrayOf(PropTypes.any).isRequired,
    validationErrors: PropTypes.arrayOf(PropTypes.string),
    readOnly: PropTypes.bool,
    canCreate: PropTypes.bool,
    canDelete: PropTypes.bool,
    canEdit: PropTypes.bool,
    canCheck: PropTypes.bool,
    configuration: PropTypes.shape({
      ctnrClassName: PropTypes.string,
      className: PropTypes.string,
    }),
    context: PropTypes.shape({}),
    viewService: PropTypes.shape({
      getComponent: PropTypes.func.isRequired,
    }).isRequired,
    treeTable: PropTypes.bool,
    cellProperties: PropTypes.shape({}),
  }

  static defaultProps = {
    context: undefined,
    configuration: undefined,
    headerButtons: undefined,
    rowButtons: undefined,
    page: undefined,
    rowsPerPage: undefined,
    sortedColumn: undefined,
    sortOrder: undefined,
    editedRow: undefined,
    validationErrors: undefined,
    readOnly: false,
    canCreate: undefined,
    canDelete: undefined,
    canEdit: undefined,
    canCheck: undefined,
    treeTable: false,
    cellProperties: undefined,
  };

  constructor(props) {
    super(props);

    const { configuration, viewService } = props;
    this.state = {};
    this.ctnrTableClassname = configuration && configuration.ctnrClassName;
    this.tableClassname = configuration && configuration.className;
    this.RowCmp = viewService.getComponent(TABLE_ROW_TYPE);
    this.ctnrRef = React.createRef();
  }

  // Render
  render() {
    const { readOnly } = this.props;
    const {
      columns,
      rowNodes,
      tableHandler,
      headerButtons,
      rowButtons,
      page,
      rowsPerPage,
      checked,
      sortedColumn,
      sortOrder,
      editedRow,
      editValues,
      validationErrors,
      canCreate = !readOnly,
      canDelete = !readOnly,
      canEdit = !readOnly,
      treeTable,
      ...rest
    } = this.props;
    const { canCheck = canDelete } = this.props;
    const rowCount = rowNodes.length;
    const pagination = rowsPerPage > 0 && rowNodes.length > rowsPerPage;
    const emptyRows = pagination ? rowsPerPage - Math.min(rowsPerPage, rowNodes.length - page * rowsPerPage) : 0;
    const numChecked = checked.length;
    const slicePageRows = (sortedRows) => {
      return pagination ? sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : sortedRows;
    };
    const cellProps = this.props.cellProperties || rest;

    return (
      <div className={classNames('tuc-table-view-ctnr', this.ctnrTableClassname)} ref={this.ctnrRef}>
        <Table className={classNames('tuc-table-view', treeTable && 'tuc-table-view-tree', this.tableClassname)}>
          <TableHead>
            <HeaderRow
              {...this.props}
              tableHandler={tableHandler}
              HeaderButtons={headerButtons}
              RowButtons={rowButtons}
              checkableCount={rowCount}
              columns={columns}
              numChecked={numChecked}
              canCheck={canCheck}
              canDelete={canDelete}
              canEdit={canEdit}
              editedRow={editedRow}
              canCreate={canCreate}
              sortedColumn={sortedColumn && (sortedColumn !== NO_SORT_PROPERTY) ? sortedColumn : undefined}
              sortOrder={sortOrder}
              handleRequestSort={this.handleRequestSort}
              checked={checked}
            />
          </TableHead>
          <TableBody>
            {slicePageRows(rowNodes).map(
              node => (
                <this.RowCmp
                  {...cellProps}
                  key={node.id}
                  row={node.obj}
                  className={node.className}
                  values={editedRow === node ? editValues : node.values}
                  fvalues={node.fvalues}
                  errors={editedRow === node ? validationErrors : undefined}
                  editing={editedRow === node}
                  selected={node.selected}
                  checked={node.checked}
                  tableHandler={tableHandler}
                  canCheck={canCheck}
                  canEdit={canEdit}
                  canDelete={canDelete}
                  RowButtons={rowButtons}
                  columns={columns}
                  showActionButtons={!editedRow}
                  leaf={!node.sortedChildren}
                  treeDepth={node.treeDepth}
                  collapsed={node.collapsed}
                />
              ),
            )}
            {emptyRows > 0 && (
              <TableRow style={{ height: 48 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
          {pagination && (
            <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={columns.length + (canEdit || canDelete || rowButtons ? 1 : 0) + (canCheck ? 1 : 0)} // + 1 for action column if any and + 1 for check column if any
                  count={rowNodes.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={tableHandler.onChangePage}
                  onChangeRowsPerPage={tableHandler.onChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </div>
    );
  }
}

export default tableWith(TableViewComponent, {
  getScrollElement: tableCmp => tableCmp.ctnrRef.current,
});
